import React, { FC, useState, useRef, useCallback, useEffect } from "react";
import TextBox from "components/atoms/TextBox";
import NextSession from "components/atoms/NextSession";
import ButtonDisabled from "components/atoms/ButtonDisabled";
import { UseFormRegister, FieldValues } from "react-hook-form";

type Props = {
  id: number;
  register: UseFormRegister<FieldValues>;
};

const AfterReading: FC<Props> = ({ id, register }) => {
  const [active, setActive] = useState(true);
  const disableAfterReading = () => setActive(false);

  const afterReadingElement = useRef<HTMLDivElement>(null);
  const scrollToAfterReadingElement = useCallback(() => {
    afterReadingElement.current?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  }, [afterReadingElement]);

  useEffect(() => {
    scrollToAfterReadingElement();
  }, [scrollToAfterReadingElement]);

  if (active) {
    return (
      <div
        id={`afterReadingElement-${id}`}
        ref={afterReadingElement}
        className="flex-none relative rounded-lg shadow-xl bg-white p-4"
      >
        <h2 className="text-lg leading-6 font-medium text-black">
          タイムアップ！
        </h2>
        <TextBox
          placeholder="読んだあとのふりかえり・次の計画"
          register={register}
          name={`afterReadingElement_${id}`}
        />
        <NextSession disableAfterReading={disableAfterReading} />
      </div>
    );
  }

  return (
    <div
      id={`afterReadingElement-${id}`}
      className="flex-none relative rounded-lg shadow-xl bg-white p-4"
    >
      <h2 className="text-lg leading-6 font-medium text-black">
        タイムアップ！
      </h2>
      <TextBox
        placeholder="読んだあとのふりかえり・次の計画"
        register={register}
        name={`afterReadingElement_${id}`}
      />
      <ButtonDisabled label="Next Session" />
    </div>
  );
};

export default AfterReading;
